module.exports = {
    methods: {
        closeNarrowNav() {
            document.querySelector('#narrow-nav-toggle').checked = false;
        }
    }
};
